export enum UrlParams {
    REDIRECT_URI = 'redirect_uri',
    MARKETPLACE_APP_ID = 'app_id',
}